import { defineMessages } from 'react-intl';

/**
 * The copy of the step-by-step "Add a song" page (design catalog-add-song a-i,
 * docs/superpowers/design-reference/catalog-add-song/). Product copy, not ASD-STE100.
 */
export const addSongFlowMessages = defineMessages({
  crumb: { id: 'app.sml.catalog.addSong.crumb', defaultMessage: 'Catalog / Add a song' },
  crumbOnboarding: {
    // One word for one thing (QA 2026-10-28, lit-10): the artist adds a song, not a "release".
    id: 'app.sml.catalog.addSong.crumb.onboarding.song',
    defaultMessage: 'Your first song / Add my song',
  },
  close: { id: 'app.sml.catalog.addSong.close', defaultMessage: 'Close' },
  notSaved: { id: 'app.sml.catalog.addSong.saved.not', defaultMessage: 'Not saved yet' },
  saving: { id: 'app.sml.catalog.addSong.saved.saving', defaultMessage: 'Saving…' },
  saved: { id: 'app.sml.catalog.addSong.saved', defaultMessage: 'Saved to Catalog' },
  stepOf: { id: 'app.sml.catalog.addSong.stepOf', defaultMessage: 'Step {step} of {total}' },
  stepOptional: { id: 'app.sml.catalog.addSong.stepOptional', defaultMessage: 'Step {step} of {total} · optional' },
  stepSong: { id: 'app.sml.catalog.addSong.step.song', defaultMessage: 'Song' },
  stepRelease: { id: 'app.sml.catalog.addSong.step.releaseDay', defaultMessage: 'Release day' },
  stepCodes: { id: 'app.sml.catalog.addSong.step.codes', defaultMessage: 'ISRC or link' },
  stepCodesIsrc: { id: 'app.sml.catalog.addSong.step.codes.isrc', defaultMessage: 'ISRC' },
  stepCodesLink: { id: 'app.sml.catalog.addSong.step.codes.link', defaultMessage: 'Link' },
  stepCover: { id: 'app.sml.catalog.addSong.step.cover', defaultMessage: 'Cover' },
  stepAudio: { id: 'app.sml.catalog.addSong.step.audio', defaultMessage: 'Audio' },
  stepLyrics: { id: 'app.sml.catalog.addSong.step.lyrics', defaultMessage: 'Lyrics' },
  next: { id: 'app.sml.catalog.addSong.next', defaultMessage: 'Next' },
  back: { id: 'app.sml.catalog.addSong.back', defaultMessage: 'Back' },
  skip: { id: 'app.sml.catalog.addSong.skip', defaultMessage: 'Skip for now' },
  finish: { id: 'app.sml.catalog.addSong.finish', defaultMessage: 'Finish' },
  coverNextHint: {
    id: 'app.sml.catalog.addSong.coverNextHint',
    defaultMessage: 'Add a cover to go on, or skip for now.',
  },
  releaseNextHint: {
    id: 'app.sml.catalog.addSong.releaseNextHint',
    defaultMessage: 'Pick one to go on.',
  },
  tryAgain: { id: 'app.sml.catalog.addSong.tryAgain', defaultMessage: 'Try again' },
  saveFailed: {
    id: 'app.sml.catalog.addSong.error.save',
    defaultMessage: 'We could not save the song. Your text is still here. Try again.',
  },
  readOnlyArtist: {
    id: 'app.sml.catalog.addSong.error.readOnly',
    defaultMessage: 'This artist is read only on your plan. Pick another artist or upgrade.',
  },
  // ---------------------------- Card ----------------------------
  cardTitle: { id: 'app.sml.catalog.addSong.card.title', defaultMessage: 'Your song' },
  cardUntitled: { id: 'app.sml.catalog.addSong.card.untitled', defaultMessage: 'Untitled song' },
  cardCoverLater: { id: 'app.sml.catalog.addSong.card.coverLater', defaultMessage: 'Cover comes later' },
  cardRelease: { id: 'app.sml.catalog.addSong.card.releaseDay', defaultMessage: 'Release day' },
  cardReleased: { id: 'app.sml.catalog.addSong.card.released', defaultMessage: 'Released' },
  cardOut: { id: 'app.sml.catalog.addSong.card.out', defaultMessage: 'Out' },
  cardIsrc: { id: 'app.sml.catalog.addSong.card.isrc', defaultMessage: 'ISRC' },
  cardUpc: { id: 'app.sml.catalog.addSong.card.upc', defaultMessage: 'UPC' },
  cardServices: { id: 'app.sml.catalog.addSong.card.services', defaultMessage: 'Services' },
  cardCover: { id: 'app.sml.catalog.addSong.card.cover', defaultMessage: 'Cover' },
  cardAudio: { id: 'app.sml.catalog.addSong.card.audio', defaultMessage: 'Audio' },
  cardLyrics: { id: 'app.sml.catalog.addSong.card.lyrics', defaultMessage: 'Lyrics' },
  cardLyricsLines: {
    id: 'app.sml.catalog.addSong.card.lyrics.lines',
    defaultMessage: '{count, plural, one {# line} other {# lines}}',
  },
  cardNotSet: { id: 'app.sml.catalog.addSong.card.notSet', defaultMessage: 'Not set' },
  cardNotAdded: { id: 'app.sml.catalog.addSong.card.notAdded', defaultMessage: 'Not added' },
  cardAdded: { id: 'app.sml.catalog.addSong.card.added', defaultMessage: 'Added' },
  cardReading: { id: 'app.sml.catalog.addSong.card.reading', defaultMessage: 'Reading the song' },
  cardReady: { id: 'app.sml.catalog.addSong.card.ready', defaultMessage: 'Ready' },
  cardSavedNote: {
    id: 'app.sml.catalog.addSong.card.savedNote',
    defaultMessage: 'Saved as a draft in your Catalog. Close any time.',
  },
  cardSaveNote: {
    id: 'app.sml.catalog.addSong.card.saveNote',
    defaultMessage: 'Saved to your Catalog after this step. Close any time. Nothing is lost.',
  },
  pillNew: { id: 'app.sml.catalog.addSong.pill.new', defaultMessage: 'New' },
  pillDraft: { id: 'app.sml.catalog.addSong.pill.draft', defaultMessage: 'Draft' },
  pillUpcoming: { id: 'app.sml.catalog.addSong.pill.upcoming', defaultMessage: 'Upcoming' },
  pillOut: { id: 'app.sml.catalog.addSong.pill.out', defaultMessage: 'Out' },
  // ---------------------------- Step 1 ----------------------------
  songQuestion: { id: 'app.sml.catalog.addSong.song.question', defaultMessage: 'What is the song called?' },
  songSub: {
    id: 'app.sml.catalog.addSong.song.sub',
    defaultMessage: 'That is all we need to start. Everything else can wait.',
  },
  songTitle: { id: 'app.sml.catalog.addSong.song.title', defaultMessage: 'Song title' },
  songTitleMissing: {
    id: 'app.sml.catalog.addSong.song.title.missing',
    defaultMessage: 'Add the song title to go on.',
  },
  songArtist: { id: 'app.sml.catalog.addSong.song.artist', defaultMessage: 'Artist' },
  songArtistHint: {
    id: 'app.sml.catalog.addSong.song.artist.hint',
    defaultMessage: 'From your artist profile. Change it for a feature or a collab.',
  },
  songFindTitle: { id: 'app.sml.catalog.addSong.song.find.title', defaultMessage: 'Already out? Find it.' },
  songFindBody: {
    id: 'app.sml.catalog.addSong.song.find.body.plain',
    defaultMessage:
      'Search for the song or the artist, or paste the link. We fill in the title, artist, cover, the ID code of the song and every service link.',
  },
  songFindButton: { id: 'app.sml.catalog.addSong.song.find.button', defaultMessage: 'Find it' },
  songShortcutButton: { id: 'app.sml.catalog.addSong.song.shortcut.button', defaultMessage: 'Paste a link' },
  songSaveNote: {
    id: 'app.sml.catalog.addSong.song.saveNote',
    defaultMessage: 'We save the song when you press Next.',
  },
  linkQuestion: { id: 'app.sml.catalog.addSong.link.question', defaultMessage: 'Paste the link to your song.' },
  linkSub: {
    id: 'app.sml.catalog.addSong.link.sub',
    defaultMessage: 'From Spotify, Apple Music, Deezer or YouTube. Or search for it. We do the typing.',
  },
  findQuestion: { id: 'app.sml.catalog.addSong.find.question', defaultMessage: 'Find your song.' },
  findSub: {
    id: 'app.sml.catalog.addSong.find.sub',
    defaultMessage:
      'Type the song or the artist name and pick it. A link from Spotify, Apple Music, Deezer or YouTube works too.',
  },
  linkTypeInstead: { id: 'app.sml.catalog.addSong.link.typeInstead', defaultMessage: 'Type it in instead' },
  // ---------------------------- Step 2 ----------------------------
  releaseQuestion: { id: 'app.sml.catalog.addSong.release.question', defaultMessage: 'When does {title} come out?' },
  releaseSub: {
    // "Pre-save" is a word a new artist does not know (QA lit-5): it says what it does.
    id: 'app.sml.catalog.addSong.release.sub.presaveHint',
    defaultMessage:
      'The date starts your countdown posts and your pre-save page: fans save the song now, and it goes into their library on release day.',
  },
  releaseOnDate: { id: 'app.sml.catalog.addSong.release.onDate', defaultMessage: 'On a date' },
  releaseOnDateBody: {
    id: 'app.sml.catalog.addSong.release.onDate.body',
    defaultMessage: 'Get a pre-save page and a countdown.',
  },
  // A plan with no pre-save (Free) is not promised a pre-save page (QA F03).
  releaseSubNoPresave: {
    id: 'app.sml.catalog.addSong.release.sub.noPresave',
    defaultMessage: 'The date starts your countdown posts.',
  },
  releaseOnDateBodyNoPresave: {
    id: 'app.sml.catalog.addSong.release.onDate.body.noPresave',
    defaultMessage: 'Get countdown posts for the release day.',
  },
  releaseNoDate: { id: 'app.sml.catalog.addSong.release.noDate', defaultMessage: 'No date yet' },
  releaseNoDateBody: {
    id: 'app.sml.catalog.addSong.release.noDate.body',
    defaultMessage: 'Add it later. The countdown waits for it.',
  },
  releaseOut: { id: 'app.sml.catalog.addSong.release.out', defaultMessage: 'It is already out' },
  releaseOutBody: {
    id: 'app.sml.catalog.addSong.release.out.body',
    defaultMessage: 'Link it to the services in the next step.',
  },
  releaseDate: { id: 'app.sml.catalog.addSong.release.date', defaultMessage: 'Release date' },
  releaseType: { id: 'app.sml.catalog.addSong.release.type', defaultMessage: 'Type' },
  // The day of "On a date" (QA brk-10): today or later, and at most two years ahead.
  releaseDatePast: {
    id: 'app.sml.catalog.addSong.release.date.past',
    defaultMessage: 'This day is in the past. Pick today or a later day.',
  },
  releaseDatePastOut: {
    id: 'app.sml.catalog.addSong.release.date.pastOut',
    defaultMessage: 'It is already out',
  },
  releaseDateTooFar: {
    id: 'app.sml.catalog.addSong.release.date.tooFar',
    defaultMessage: 'Pick a day in the next two years.',
  },
  releaseDateMissing: {
    id: 'app.sml.catalog.addSong.release.date.missing',
    defaultMessage: 'Pick the release day to go on.',
  },
  optional: { id: 'app.sml.catalog.addSong.optional', defaultMessage: 'optional' },
  typeSingle: { id: 'app.sml.catalog.addSong.type.single', defaultMessage: 'Single' },
  typeEp: { id: 'app.sml.catalog.addSong.type.ep', defaultMessage: 'EP' },
  typeAlbum: { id: 'app.sml.catalog.addSong.type.album', defaultMessage: 'Album' },
  releaseOutInfo: {
    id: 'app.sml.catalog.addSong.release.out.info',
    defaultMessage:
      'Next, paste one link to the song. We bring the cover, the release date and the links to every service.',
  },
  // ---------------------------- Step 3 ----------------------------
  codesQuestion: { id: 'app.sml.catalog.addSong.codes.question', defaultMessage: 'Do you have the codes?' },
  codesSub: {
    id: 'app.sml.catalog.addSong.codes.sub.plain',
    defaultMessage:
      'Your distributor (DistroKid, TuneCore, CD Baby and others) gives you these ID codes. With them we find {title} on release day and link every service for you.',
  },
  upc: { id: 'app.sml.catalog.addSong.codes.upc', defaultMessage: 'UPC' },
  // The hint and the error say the same rule (QA lit-14, brk-19): 12 to 14 numbers.
  upcHint: {
    id: 'app.sml.catalog.addSong.codes.upc.hint.range',
    defaultMessage: 'The ID code of the whole single, EP or album: 12 to 14 numbers (also called EAN).',
  },
  isrcHint: {
    id: 'app.sml.catalog.addSong.codes.isrc.hint',
    defaultMessage: 'The ID code of this song. Example: GBABC2600042.',
  },
  // QA 2026-10-28 litr2-4: the error keeps the example, so it is there when it is needed.
  isrcErrorExample: { id: 'app.sml.catalog.addSong.codes.isrc.errorExample', defaultMessage: 'Example: GBABC2600042.' },
  upcError: { id: 'app.sml.catalog.addSong.codes.upc.error', defaultMessage: 'A UPC has 12 to 14 numbers.' },
  codesLater: {
    id: 'app.sml.catalog.addSong.codes.later',
    defaultMessage: 'No codes yet? Skip this. Add them on the song page when your distributor sends them.',
  },
  codesAlreadyOut: { id: 'app.sml.catalog.addSong.codes.alreadyOut', defaultMessage: 'Already out? Link it instead' },
  linkStepQuestion: { id: 'app.sml.catalog.addSong.linkStep.question', defaultMessage: 'Where can fans hear {title}?' },
  linkStepSub: {
    id: 'app.sml.catalog.addSong.linkStep.sub',
    defaultMessage: 'Pick the match we found, or paste a link. We add the cover and every service.',
  },
  linkStepMatch: {
    id: 'app.sml.catalog.addSong.linkStep.match',
    defaultMessage: 'We found {title} by {artist} in the music catalog.',
  },
  linkStepYes: { id: 'app.sml.catalog.addSong.linkStep.yes', defaultMessage: 'Yes, link it' },
  linkStepOr: { id: 'app.sml.catalog.addSong.linkStep.or', defaultMessage: 'or' },
  linkStepLabel: { id: 'app.sml.catalog.addSong.linkStep.label', defaultMessage: 'Song link' },
  linkStepUse: { id: 'app.sml.catalog.addSong.linkStep.use', defaultMessage: 'Use this link' },
  linkStepNotOut: {
    id: 'app.sml.catalog.addSong.linkStep.notOut',
    defaultMessage: 'Not out yet? Add the codes instead',
  },
  // ---------------------------- Step 4 ----------------------------
  coverQuestion: { id: 'app.sml.catalog.addSong.cover.question', defaultMessage: 'Add the cover' },
  coverDoneQuestion: { id: 'app.sml.catalog.addSong.cover.done.question', defaultMessage: 'Looks good.' },
  coverSub: {
    id: 'app.sml.catalog.addSong.cover.sub',
    defaultMessage: 'Every post, story and video takes its colours from it.',
  },
  coverSlot: { id: 'app.sml.catalog.addSong.cover.slot', defaultMessage: 'Your cover goes here' },
  coverUpload: { id: 'app.sml.catalog.addSong.cover.upload', defaultMessage: 'Upload cover' },
  // The square slot is a second way to pick the file: it has its own name (QA imp-11).
  coverSlotLabel: {
    id: 'app.sml.catalog.addSong.cover.slot.label',
    defaultMessage: 'Cover preview. Pick a picture file.',
  },
  coverUploadBodyTouch: {
    id: 'app.sml.catalog.addSong.cover.upload.body.touch',
    defaultMessage: 'Tap to pick a JPG, PNG or WebP picture. Square works best. Up to {max} MB.',
  },
  coverUploadBody: {
    id: 'app.sml.catalog.addSong.cover.upload.body',
    defaultMessage: 'Drop a JPG, PNG or WebP here, or pick a file. Square works best. Up to {max} MB.',
  },
  coverUploading: { id: 'app.sml.catalog.addSong.cover.uploading', defaultMessage: 'Uploading your cover' },
  coverDesignTitle: { id: 'app.sml.catalog.addSong.cover.design.title', defaultMessage: 'No cover yet? Make one.' },
  coverDesignBody: {
    id: 'app.sml.catalog.addSong.cover.design.body',
    defaultMessage: 'Pick a background, add the title. About two minutes in the cover editor.',
  },
  coverDesign: { id: 'app.sml.catalog.addSong.cover.design', defaultMessage: 'Design a cover' },
  coverOnSong: { id: 'app.sml.catalog.addSong.cover.onSong', defaultMessage: 'The cover is on the song now.' },
  coverDifferent: { id: 'app.sml.catalog.addSong.cover.different', defaultMessage: 'Want a different one?' },
  coverReplaces: { id: 'app.sml.catalog.addSong.cover.replaces', defaultMessage: 'The new cover replaces this one.' },
  coverReplaceFile: { id: 'app.sml.catalog.addSong.cover.replaceFile', defaultMessage: 'Replace with a file' },
  coverDesignNew: { id: 'app.sml.catalog.addSong.cover.designNew', defaultMessage: 'Design a new cover' },
  coverCarriedTitle: {
    id: 'app.sml.catalog.addSong.cover.carried.title',
    defaultMessage: 'Your design from the artwork maker',
  },
  coverCarriedBody: {
    id: 'app.sml.catalog.addSong.cover.carried.body',
    defaultMessage: 'It goes on this song and opens in the cover editor.',
  },
  coverUseCarried: { id: 'app.sml.catalog.addSong.cover.carried.use', defaultMessage: 'Use my design' },
  // ---------------------------- Step 5 ----------------------------
  audioQuestion: { id: 'app.sml.catalog.addSong.audio.question', defaultMessage: 'Add the song audio' },
  audioSub: {
    id: 'app.sml.catalog.addSong.audio.sub',
    defaultMessage: 'Your images are ready to go. The audio turns them into videos.',
  },
  audioUploadingQuestion: {
    id: 'app.sml.catalog.addSong.audio.uploading.question',
    defaultMessage: 'Uploading {title}',
  },
  audioUploadingSub: {
    id: 'app.sml.catalog.addSong.audio.uploading.sub',
    defaultMessage: 'Keep this page open until the upload ends.',
  },
  audioDoneQuestion: { id: 'app.sml.catalog.addSong.audio.done.question', defaultMessage: 'Got it.' },
  audioDoneSub: {
    id: 'app.sml.catalog.addSong.audio.done.sub.plain',
    defaultMessage:
      'We make a copy to play in the app, and find the beats and the catchiest part (the hook). Your videos use both.',
  },
  // "Master" made a new artist think of a special file (QA lit-5); a phone has no drag and drop (mob-19).
  audioDropTitle: {
    id: 'app.sml.catalog.addSong.audio.drop.final',
    defaultMessage: 'Add the final audio file of your song',
  },
  audioDropTitleTouch: {
    id: 'app.sml.catalog.addSong.audio.drop.touch',
    defaultMessage: 'Pick the audio file of your song',
  },
  audioDropHint: {
    id: 'app.sml.catalog.addSong.audio.drop.hint.master',
    defaultMessage:
      'WAV, FLAC, AIFF, MP3, M4A or AAC, up to {max} MB. Use the master if you have it: the final, best-quality mix.',
  },
  audioDropHintTouch: {
    id: 'app.sml.catalog.addSong.audio.drop.hint.touch',
    defaultMessage:
      'An MP3 or M4A from your phone is fine for now. Add the master (the final, best-quality mix) later on the song page. Up to {max} MB.',
  },
  audioUnlocks: { id: 'app.sml.catalog.addSong.audio.unlocks', defaultMessage: 'What the audio unlocks' },
  audioUnlocked: { id: 'app.sml.catalog.addSong.audio.unlocked', defaultMessage: 'Unlocked for {title}' },
  audioStudio: { id: 'app.sml.catalog.addSong.audio.studio', defaultMessage: 'Studio videos' },
  audioStudioBody: {
    id: 'app.sml.catalog.addSong.audio.studio.body.canvas',
    defaultMessage:
      'Short videos, countdowns and the Canvas loop (the short moving picture behind your song in Spotify), cut to your song.',
  },
  audioReel: { id: 'app.sml.catalog.addSong.audio.reel', defaultMessage: 'AI reel' },
  audioReelBody: {
    id: 'app.sml.catalog.addSong.audio.reel.body',
    defaultMessage: 'A 15 or 30 second reel, cut on the beat.',
  },
  audioSync: { id: 'app.sml.catalog.addSong.audio.sync', defaultMessage: 'Lyric sync' },
  audioSyncBody: {
    id: 'app.sml.catalog.addSong.audio.sync.body',
    defaultMessage: 'Add the lyrics in the next step. We time every line to the audio.',
  },
  audioFull: { id: 'app.sml.catalog.addSong.audio.full', defaultMessage: 'Full-song videos' },
  audioFullBody: {
    id: 'app.sml.catalog.addSong.audio.full.body',
    defaultMessage: 'Lyric video, visualizer and music video for YouTube.',
  },
  audioPro: { id: 'app.sml.catalog.addSong.audio.pro', defaultMessage: 'Pro' },
  audioFree: { id: 'app.sml.catalog.addSong.audio.free', defaultMessage: 'Free plan' },
  audioFreeBody: {
    id: 'app.sml.catalog.addSong.audio.free.body.small',
    defaultMessage: 'Videos on Free are small previews with the MUSIC24 mark. Full-song videos need Pro.',
  },
  audioTrial: { id: 'app.sml.catalog.addSong.audio.trial', defaultMessage: 'Trial' },
  audioTrialBody: {
    id: 'app.sml.catalog.addSong.audio.trial.body.small',
    defaultMessage:
      'In the trial, videos are small previews with the MUSIC24 mark. A paid plan makes them in full quality.',
  },
  audioReading: {
    id: 'app.sml.catalog.addSong.audio.reading',
    defaultMessage: 'Reading the song: beats, sections, the hook',
  },
  audioReadingNote: {
    id: 'app.sml.catalog.addSong.audio.reading.note',
    defaultMessage: 'This runs on our side. You can go on now.',
  },
  audioPlayReady: { id: 'app.sml.catalog.addSong.audio.playReady', defaultMessage: 'Play copy ready' },
  audioUpload: { id: 'app.sml.catalog.addSong.audio.upload', defaultMessage: 'Upload audio' },
  // A press on "Upload audio" before the rights box is ticked (QA imp-3).
  audioRightsFirst: {
    id: 'app.sml.catalog.addSong.audio.rightsFirst',
    defaultMessage: 'Tick the box above to upload.',
  },
  audioNotAudio: {
    id: 'app.sml.catalog.addSong.audio.notAudio',
    defaultMessage: 'This file is not audio. Pick the WAV, FLAC, AIFF, MP3, M4A or AAC file of your song.',
  },
  // ---------------------------- Step 6 ----------------------------
  lyricsQuestion: { id: 'app.sml.catalog.addSong.lyrics.question', defaultMessage: 'Add the lyrics' },
  lyricsSub: {
    id: 'app.sml.catalog.addSong.lyrics.sub',
    defaultMessage: 'Lyric cards, lyric stories and the lyric video use them. We time every line to the song for you.',
  },
  lyricsLabel: { id: 'app.sml.catalog.addSong.lyrics.label', defaultMessage: 'Lyrics' },
  lyricsPlaceholder: {
    id: 'app.sml.catalog.addSong.lyrics.placeholder',
    defaultMessage: 'Paste the lyrics here. One line per sung line. Section names like [Chorus] are fine.',
  },
  lyricsPlain: { id: 'app.sml.catalog.addSong.lyrics.plain', defaultMessage: 'Plain text' },
  lyricsTooLong: {
    id: 'app.sml.catalog.addSong.lyrics.tooLong',
    defaultMessage: 'Lyrics can be up to {max} characters.',
  },
  lyricsWithAudio: {
    id: 'app.sml.catalog.addSong.lyrics.withAudio',
    defaultMessage: 'Your audio is in. We start timing the lines as soon as you finish. It takes about a minute.',
  },
  lyricsNoAudio: {
    id: 'app.sml.catalog.addSong.lyrics.noAudio',
    defaultMessage: 'No audio yet. We time the lines when you add the audio on the song page.',
  },
  lyricsSaveFailed: {
    id: 'app.sml.catalog.addSong.lyrics.saveFailed',
    defaultMessage: 'We could not save the lyrics. Try again.',
  },
  // ---------------------------- Done ----------------------------
  doneQuestion: { id: 'app.sml.catalog.addSong.done.question', defaultMessage: '{title} is in your Catalog.' },
  doneSubPresave: {
    id: 'app.sml.catalog.addSong.done.sub.presave',
    defaultMessage: 'It is ready to promote. Start with the pre-save: every save is a fan who hears it on day one.',
  },
  doneSubReleased: {
    id: 'app.sml.catalog.addSong.done.sub.released',
    defaultMessage: 'One link to every service is the fastest win. Put it in your bio today.',
  },
  doneSubNoDate: {
    id: 'app.sml.catalog.addSong.done.sub.noDate',
    defaultMessage: 'It is ready to promote. Make the first images now, and add the release day when you know it.',
  },
  donePresave: { id: 'app.sml.catalog.addSong.done.presave', defaultMessage: 'Get the pre-save page' },
  donePresaveBody: {
    id: 'app.sml.catalog.addSong.done.presave.body',
    defaultMessage: 'Fans save {title} now. It lands in their library on release day.',
  },
  donePresaveButton: { id: 'app.sml.catalog.addSong.done.presave.button', defaultMessage: 'Make the pre-save page' },
  doneSmartLink: { id: 'app.sml.catalog.addSong.done.smartLink', defaultMessage: 'Make a SmartLink' },
  doneSmartLinkBody: {
    id: 'app.sml.catalog.addSong.done.smartLink.body',
    defaultMessage: 'One page with every service. Ready in seconds.',
  },
  doneSmartLinkButton: { id: 'app.sml.catalog.addSong.done.smartLink.button', defaultMessage: 'Make the SmartLink' },
  doneKit: { id: 'app.sml.catalog.addSong.done.kit', defaultMessage: 'Make the release kit' },
  doneKitBody: {
    id: 'app.sml.catalog.addSong.done.kit.body',
    defaultMessage: 'Stories, posts, cover sizes and videos in one look. The images are free.',
  },
  doneKitButton: { id: 'app.sml.catalog.addSong.done.kit.button', defaultMessage: 'Open Studio' },
  doneKitFree: {
    id: 'app.sml.catalog.addSong.done.kit.free',
    defaultMessage: 'Free promotes one release at a time. Promote more songs at once on Plus.',
  },
  doneKitFreeOther: {
    id: 'app.sml.catalog.addSong.done.kit.freeOther',
    defaultMessage:
      'Free promotes one release at a time. {title} is active until {date}. Promote both on Plus, {price} a month.',
  },
  donePagesLabel: { id: 'app.sml.catalog.addSong.done.pages.label', defaultMessage: 'Published pages' },
  donePagesMeter: { id: 'app.sml.catalog.addSong.done.pages.meter', defaultMessage: '{used} of {limit} on Free' },
  donePagesFull: {
    id: 'app.sml.catalog.addSong.done.pages.full',
    defaultMessage: 'You use {used} of {limit} pages on Free',
  },
  doneSongPage: { id: 'app.sml.catalog.addSong.done.songPage', defaultMessage: 'Open the song page' },
  doneSongPageBody: {
    id: 'app.sml.catalog.addSong.done.songPage.body',
    defaultMessage: 'Check every detail and play the master.',
  },
  doneSongPageButton: { id: 'app.sml.catalog.addSong.done.songPage.button', defaultMessage: 'Open song page' },
  doneMissing: { id: 'app.sml.catalog.addSong.done.missing', defaultMessage: 'Not added yet:' },
  doneFind: { id: 'app.sml.catalog.addSong.done.find', defaultMessage: 'You find {title} in your Catalog any time.' },
  doneAnother: { id: 'app.sml.catalog.addSong.done.another', defaultMessage: 'Add another song' },
  doneBack: { id: 'app.sml.catalog.addSong.done.back', defaultMessage: 'Back to Catalog' },
  doneBackDesign: { id: 'app.sml.catalog.addSong.done.backDesign', defaultMessage: 'Back to your design' },
  doneOnboardingQuestion: {
    id: 'app.sml.catalog.addSong.done.onboarding.question',
    defaultMessage: '{title} is in. Your first images are on the way.',
  },
  doneOnboardingSub: {
    id: 'app.sml.catalog.addSong.done.onboarding.sub',
    defaultMessage: 'Stories, posts and cover sizes, free. Your release page opens in a moment.',
  },
  doneOnboardingAdded: {
    id: 'app.sml.catalog.addSong.done.onboarding.added',
    defaultMessage: 'Song added to your Catalog',
  },
  doneOnboardingFirst: {
    id: 'app.sml.catalog.addSong.done.onboarding.first',
    defaultMessage: 'Set as your first release',
  },
  doneOnboardingImages: {
    id: 'app.sml.catalog.addSong.done.onboarding.images',
    defaultMessage: 'Starting your free images',
  },
  doneOnboardingPresave: {
    id: 'app.sml.catalog.addSong.done.onboarding.presave',
    defaultMessage: 'Making your pre-save page',
  },
  doneOnboardingPresaveLive: {
    id: 'app.sml.catalog.addSong.done.onboarding.presaveLive',
    defaultMessage: 'Your pre-save page is live: {url}',
  },
  doneOnboardingPresaveLiveToast: {
    id: 'app.sml.catalog.addSong.done.onboarding.presaveLiveToast',
    defaultMessage: 'Your pre-save page is live.',
  },
  doneOnboardingOpen: { id: 'app.sml.catalog.addSong.done.onboarding.open', defaultMessage: 'Open my release' },
  bioTick: { id: 'app.sml.catalog.addSong.bioTick', defaultMessage: 'Auto add to my Bio Link' },
  bioTickOn: {
    id: 'app.sml.catalog.addSong.bioTick.on.plain',
    defaultMessage:
      'Your Bio Link is your one artist page with all your links. The song goes on it: a pre-save button before release day, then the play buttons.',
  },
  bioTickOffBySetting: {
    id: 'app.sml.catalog.addSong.bioTick.offBySetting',
    defaultMessage: 'Off for new songs in your Bio Link settings. Tick to add this song anyway.',
  },
  bioTickOffByHand: {
    id: 'app.sml.catalog.addSong.bioTick.offByHand',
    defaultMessage: 'This song stays off your Bio Link page. You can add it later.',
  },
  cardBioLink: { id: 'app.sml.catalog.addSong.card.bioLink', defaultMessage: 'Bio Link' },
  cardBioLinkOnSave: { id: 'app.sml.catalog.addSong.card.bioLink.onSave', defaultMessage: 'Adds on save' },
  cardBioLinkAdded: { id: 'app.sml.catalog.addSong.card.bioLink.added', defaultMessage: 'Added' },
  doneBioLive: { id: 'app.sml.catalog.addSong.done.bio.live', defaultMessage: 'On your Bio Link now' },
  doneBioLiveBody: {
    id: 'app.sml.catalog.addSong.done.bio.live.body',
    defaultMessage:
      '{address} shows the {title} {kind, select, presave {pre-save} other {play buttons}} {place, select, end {at the end of the page} other {under your profile}}.',
  },
  doneBioNotLive: {
    id: 'app.sml.catalog.addSong.done.bio.notLive',
    defaultMessage: 'Added to your Bio Link. Publish it to show fans.',
  },
  doneBioDraftRemoved: {
    id: 'app.sml.catalog.addSong.done.bio.draftRemoved',
    defaultMessage: 'Removed from your draft. Publish the Bio Link to take it off the page.',
  },
  doneBioAdd: { id: 'app.sml.catalog.addSong.done.bio.add', defaultMessage: 'Add {title} to your Bio Link' },
  doneBioAddBody: {
    id: 'app.sml.catalog.addSong.done.bio.add.body',
    defaultMessage: 'Fans who open your Bio Link see the song first.',
  },
  doneBioUndone: { id: 'app.sml.catalog.addSong.done.bio.undone', defaultMessage: 'Not on your Bio Link' },
  doneBioAddButton: { id: 'app.sml.catalog.addSong.done.bio.addButton', defaultMessage: 'Add' },
  doneBioAddItButton: { id: 'app.sml.catalog.addSong.done.bio.addItButton', defaultMessage: 'Add it' },
  doneBioOpen: { id: 'app.sml.catalog.addSong.done.bio.open', defaultMessage: 'Open Bio Link' },
  doneBioUndo: { id: 'app.sml.catalog.addSong.done.bio.undo', defaultMessage: 'Undo' },
  doneBioFailed: {
    id: 'app.sml.catalog.addSong.done.bio.failed',
    defaultMessage: 'We could not change your Bio Link. Try again.',
  },
  closedToast: {
    id: 'app.sml.catalog.addSong.closedToast',
    defaultMessage: '{title} is saved in your Catalog. Finish it any time.',
  },
});
